import { IDeleteSatisfacaoClienteUseCase } from "../../../presentation/useCases/delete/delete_satisfacao_cliente_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteSatisfacaoClienteUseCase
 */

export class DeleteSatisfacaoClienteUseCase implements IDeleteSatisfacaoClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async deleteSatisfacaoCliente(
    idSatisfacaoCliente: number,
  ): Promise<void> {
    await this.repository.deleteSatisfacaoCliente(
      idSatisfacaoCliente,
    );
  }
}
